import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'ko_KR',
  {
    fdidYouMean: true,
    ffacetNavigation: true,
    fdomainSuggestions: true,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: true,
  },
  {
    fssInputCategory: false,
  },
  '61c87f57-0c2f-11ed-97bf-16e3d61b9114',
  ''
);
